import { useEffect } from "react";
import { urlTemp } from "../../Config/Functions/Functions";

const ShareDesktopSticky = ({ data }) => {
    useEffect(() => {
        const load = async () => {
            if (typeof window !== undefined) {
                const ScrollMagic = (await import('scrollmagic')).default;
                let controller = new ScrollMagic.Controller;
                var a = new ScrollMagic.Scene({
                    triggerElement: ".autor-share-container",
                    offset: 59,
                    triggerHook: 0
                }).addTo(controller);
                a.on("enter", function (a) {
                    document.querySelector(".nota-desktop-share.flex-column").classList.add("show-me");

                }), a.on("leave", function (a) {
                    document.querySelector(".nota-desktop-share.flex-column").classList.remove("show-me");

                });

            }
        }
        load()
    }, [])
    return (
        <>
            <div className="nota-desktop-share vertical-share flex-container flex-column hide-mobile">
                <a href={`https://www.facebook.com/sharer/sharer.php?u=${urlTemp + data?.info?.link?.url}`} className="flex-container align-center justify-center" title="Compartir por Facebook" target="_blank" rel="noopener noreferrer">
                    <svg className="fb-icon" viewBox="0 0 8.65 16">
                        <g>
                            <path d="M30.4,0,28.327,0a3.644,3.644,0,0,0-3.837,3.938V5.753H22.4a.326.326,0,0,0-.326.326V8.71a.326.326,0,0,0,.326.326h2.086v6.637a.326.326,0,0,0,.326.326h2.722a.326.326,0,0,0,.326-.326V9.036H30.3a.326.326,0,0,0,.326-.326V6.08a.326.326,0,0,0-.326-.326h-2.44V4.214c0-.74.176-1.115,1.14-1.115h1.4a.326.326,0,0,0,.326-.326V.33A.326.326,0,0,0,30.4,0Z" transform="translate(-22.077)" fill="#4C5299" />
                        </g>
                    </svg>
                </a>
                <a href={`http://twitter.com/intent/tweet?url=${urlTemp + data?.info?.link?.url}&text=${data?.main?.title?.home}&via=cronica`} className="flex-container align-center justify-center" title="Compartir por Twitter" target="_blank" rel="noopener noreferrer">
                    <svg className="tw-icon" viewBox="0 0 19.692 16">
                        <g>
                            <path d="M0.039062 0L6.21611 8.26113L0 14.9749H1.39901L6.84143 9.09587L11.24 14.9752H15.9997L9.47467 6.25091L15.2608 0H13.8618L8.84968 5.41354L4.7997 0H0.039062ZM2.09655 1.03071H4.28369L13.9412 13.9442H11.7547L2.09655 1.03071Z"  fill="#00ACEE" />
                        </g>
                    </svg>
                </a>
                <a href={`https://web.whatsapp.com/send?text=Mirá esta noticia: ${urlTemp + data?.info?.link?.url}`} className="flex-container align-center justify-center" title="Compartir por WhatsApp" target="_blank" rel="noopener noreferrer">
                    <svg className="wsp-icon" viewBox="0 0 18 18">
                        <g>
                            <path d="M18,8.768A8.851,8.851,0,0,1,4.892,16.445L0,18l1.6-4.7A8.676,8.676,0,0,1,.327,8.768,8.837,8.837,0,0,1,18,8.768ZM9.164,1.4A7.409,7.409,0,0,0,1.734,8.768,7.294,7.294,0,0,0,3.15,13.09l-.928,2.738,2.855-.907A7.437,7.437,0,0,0,16.593,8.769,7.409,7.409,0,0,0,9.164,1.4Zm4.462,9.391c-.055-.089-.2-.143-.415-.251s-1.282-.628-1.48-.7-.343-.108-.488.107-.559.7-.686.842-.253.162-.469.054A5.929,5.929,0,0,1,8.346,9.775,6.48,6.48,0,0,1,7.141,8.287c-.126-.215-.013-.331.095-.438s.217-.251.325-.376a1.441,1.441,0,0,0,.216-.359.392.392,0,0,0-.018-.377c-.054-.107-.488-1.165-.668-1.6s-.361-.358-.487-.358-.271-.018-.415-.018a.8.8,0,0,0-.578.269,2.4,2.4,0,0,0-.758,1.793,4.159,4.159,0,0,0,.884,2.223,8.854,8.854,0,0,0,3.7,3.245c2.2.86,2.2.573,2.6.537A2.191,2.191,0,0,0,13.5,11.81,1.792,1.792,0,0,0,13.626,10.788Z" fill="#86DA50" />
                        </g>
                    </svg>
                </a>
                <a href={`fb-messenger://share/?link=${urlTemp + data?.info?.link?.url}&app_id=770691799758883`} className="flex-container align-center justify-center hide-desktop" title="Compartir por Messenger" target="_blank" rel="noopener noreferrer">
                    <svg className="msgr-icon" viewBox="0 0 16 16">
                        <g>
                            <path d="M263.506,514.785l-2.037-2.172-3.975,2.172,4.372-4.641,2.087,2.172,3.925-2.172Zm-.795-9.975c-4.418,0-8,3.316-8,7.407a7.2,7.2,0,0,0,2.981,5.769v2.824l2.724-1.495a8.616,8.616,0,0,0,2.3.31c4.418,0,8-3.316,8-7.408S267.129,504.81,262.711,504.81Z" transform="translate(-254.711 -504.81)" fill="#0078FF" />
                        </g>
                    </svg>
                </a>
                <a href={`mailto:?subject=Te recomiendo esta nota de Crónica&amp;body=Lee esta nota de Crónica&nbsp;${data?.main?.title?.home}&nbsp;${urlTemp + data?.info?.link?.url}`} className="flex-container align-center justify-center" title="Compartir por email" target="_blank" rel="noopener noreferrer">
                    <svg className="mail-icon" viewBox="0 0 24 17.143">
                        <g>
                            <path d="M351.969,12.4l8.485,7.273a1.726,1.726,0,0,1-1.18.468H338.726a1.731,1.731,0,0,1-1.184-.464l8.489-7.276L349,15ZM349,13.286,337.546,3.468A1.726,1.726,0,0,1,338.726,3h20.548a1.731,1.731,0,0,1,1.184.464Zm12,5.461-8.285-7.04L361,4.5V18.747Zm-24,0V4.505l8.285,7.2L337,18.747Zm0,0" transform="translate(-337 -3)" fill="#777777" fillRule="evenodd" />
                        </g>
                    </svg>
                </a>
            </div>
        </>
    )
}

export default ShareDesktopSticky;